var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.109,
    height: 74.109,
    viewBox: "0 0 74.109 74.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-6 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18739",
    "data-name": "Group 18739",
    transform: "translate(21.107 49.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7501",
    "data-name": "Path 7501",
    d: "M38.548,63.4a2.814,2.814,0,0,1-2-.855l-19.1-19.1a2.822,2.822,0,0,1,3.991-3.991l19.1,19.1a2.755,2.755,0,0,1,0,3.99A2.814,2.814,0,0,1,38.548,63.4Z",
    transform: "translate(-16.6 -38.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18740",
    "data-name": "Group 18740",
    transform: "translate(40.204 49.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7502",
    "data-name": "Path 7502",
    d: "M32.85,63.4a2.814,2.814,0,0,1-2-.855,2.755,2.755,0,0,1,0-3.991l19.1-19.1a2.822,2.822,0,0,1,3.99,3.991l-19.1,19.1A2.814,2.814,0,0,1,32.85,63.4Z",
    transform: "translate(-30 -38.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18741",
    "data-name": "Group 18741",
    transform: "translate(40.204 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    d: "M32.85,73.858A2.859,2.859,0,0,1,30,71.007V16.85a2.85,2.85,0,1,1,5.7,0V71.007A2.859,2.859,0,0,1,32.85,73.858Z",
    transform: "translate(-30 -14)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/Icon_Back.9cbf6a0ddb64018b904d1f5e87a36a82.svg";
export { ForwardRef as ReactComponent };